export enum XrplQueryKeys {
  AccountInfo = 'account_info',
  AccountLines = 'account_lines',
  AccountOffers = 'account_offers',
  AccountTx = 'account_tx',
  BookOffers = 'book_offers',
  BookChanges = 'book_changes',
  OfferCancel = 'offer_cancel',
  ExecuteXrplTransaction = 'execute_xrpl_transaction',
  GetAggregatePrice = 'get_aggregate_price',
  RipplePathFind = 'ripple_path_find',
  ServerInfo = 'server_info',
  Subscribe = 'subscribe',
  Transaction = 'tx',
  Unsubscribe = 'unsubscribe',
}

// Book Changes types (for candlestick charts)
export interface BookUpdate {
  currency_a: string;
  currency_b: string;
  volume_a: string;
  volume_b: string;
  high: string;
  low: string;
  open: string;
  close: string;
}

export interface BookChangesRequest {
  command: 'book_changes';
  ledger_hash?: string;
  ledger_index?: number | string;
}

export interface BookChangesResponse {
  result: {
    type: 'bookChanges';
    ledger_hash: string;
    ledger_index: number;
    ledger_time: number;
    validated?: boolean;
    changes: BookUpdate[];
  };
}
